import type { ReactNode } from "react"

import { Badge } from "@/components/ui/badge"
import {
  dataBySourceRecordAttribution,
  SourceRecordAttribution,
} from "@/constants/terminal/source-record-attribution"

// The building blocks both evidence sheets share: Research Task receipts and
// File evidence.
export const EvidenceSection = ({
  title,
  children,
}: {
  title: string
  children: ReactNode
}) => (
  <section className="space-y-3">
    <h3 className="text-sm font-semibold">{title}</h3>
    {children}
  </section>
)

export const Facts = ({ children }: { children: ReactNode }) => (
  <dl className="grid grid-cols-[7rem_minmax(0,1fr)] gap-x-4 gap-y-1.5 text-xs">
    {children}
  </dl>
)

export const Fact = ({ label, value }: { label: string; value: ReactNode }) => (
  <>
    <dt className="text-muted-foreground">{label}</dt>
    <dd className="break-words">{value}</dd>
  </>
)

const attributionVariant = (attribution: SourceRecordAttribution | null) => {
  if (attribution === SourceRecordAttribution.IN_SCOPE) return "good"
  if (attribution === SourceRecordAttribution.UNRESOLVED) return "caution"
  return "secondary"
}

export const AttributionBadge = ({
  attribution,
}: {
  attribution: SourceRecordAttribution | null
}) => (
  <Badge variant={attributionVariant(attribution)}>
    {attribution
      ? dataBySourceRecordAttribution[attribution].label
      : "Not attributed yet"}
  </Badge>
)
